<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>店铺装修</el-breadcrumb-item>
			<el-breadcrumb-item>底部菜单设置</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">

			<el-form-item label="图片">
				<el-upload list-type="picture" :on-remove="uploadRemove" :on-success="uploadSuccess" :file-list="pic"
					:on-error="uploadError" :before-upload="beforeUpload" drag :action="app_url + '/store/uploader/upload'"
					accept="image/jpeg,image/png">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">
						将文件拖到此处，或<em>点击上传</em>
						<br /><br />
					</div>
				</el-upload>
			</el-form-item>

			<el-form-item label="链接">
				<el-input placeholder="请输入链接" v-model="item.page"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				dialogVisible: false,
				id: this.$route.query.id,
				dialogVisibleCarousel: false,
				pic: [],
				rules: {
					// carouselImg: [
					//     {required: true, message: '首页底部菜单不存在'},
					// ],
				}
			}
		},
		created() {
			if (this.id) {
				this.loadData()
			}
		},
		methods: {
			loadData: function() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				// 获取底部菜单信息
				this.axios.post('', {
					id: this.id
				}).then(res => {
					this.isLoad = !this.isLoad
					// item是基础信息
					this.item = res.data
					if (this.item.pic) {
						this.pic = [{
							name: res.data.pic,
							url: res.data.pic,
							response: {
								data: {
									src: res.data.pic
								}
							}
						}]
					}
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false

				if (this.pic[0]) {
					this.$set(this.item, 'pic', this.pic[0].response.data.src)
				} else {
					this.$set(this.item, 'pic', '')
				}

				this.item.navShort = this.carouselItem
				let url = ''
				if(this.id){
					url=''
				}else{
					url = '/store/fitment/navMenu'
				}

				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			//上传失败通用
			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			//上传成功 非通用
			uploadSuccess(res, file) {
				file.name = res.data.src
				this.pic = [file]
				this.$message.success({
					message: '上传成功'
				});
			},
			//图片移除 非通用
			uploadRemove: function() {
				this.pic = []
			},
			//格式检查 通用
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
		}
	}
</script>

<style>
</style>
